function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlinedapplication/video-camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3i998p1nta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/video-camera (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/video-camera (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlinedapplication/video-camera",
    style: {
      clipPath: "url(#3i998p1nta)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlinedapplication/video-camera (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/video-camera (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.093 15.125H1.375A1.376 1.376 0 0 1 0 13.75V1.375A1.377 1.377 0 0 1 1.375 0h12.718a1.377 1.377 0 0 1 1.375 1.375v3.266l2.75-1.583a.677.677 0 0 1 .343-.093.689.689 0 0 1 .689.688v7.823a.688.688 0 0 1-.689.686.677.677 0 0 1-.342-.093l-2.75-1.584v3.265a1.376 1.376 0 0 1-1.376 1.375zM1.547 1.547v12.031h12.375V1.547zM17.7 5.135l-2.231 1.287v2.283L17.7 9.99zM5.5 4.3H3.094a.172.172 0 0 1-.172-.172V3.094a.172.172 0 0 1 .172-.172H5.5a.172.172 0 0 1 .172.172v1.031A.172.172 0 0 1 5.5 4.3z",
    transform: "translate(1.375 3.438)",
    style: {
      fill: "#1cb691"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.41990c5c5342d366aa963240ed0cd922.svg";
export { ForwardRef as ReactComponent };